// extracted by mini-css-extract-plugin
module.exports = {"container":"ListingsPanel_container__2o7n6","card":"ListingsPanel_card__3HRYE","header":"ListingsPanel_header__2e3z1","title":"ListingsPanel_title__3-00e"};